export default __webpack_public_path__ + "fb2261956bdf9ff9e07eb6a2adb1ffa7.png";